/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9hbmFseXRpY3MtZnJvbnQvYW5hbHl0aWNzLWxhdGVzdC1hY3Rpdml0eS9hbmFseXRpY3MtbGF0ZXN0LWFjdGl2aXR5LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2Zyb250L2FuYWx5dGljcy1mcm9udC9hbmFseXRpY3MtbGF0ZXN0LWFjdGl2aXR5L2FuYWx5dGljcy1sYXRlc3QtYWN0aXZpdHkuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/analytics-front/analytics-latest-activity/analytics-latest-activity.component.css.shim.ngstyle.ts